var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.hasData)?_c('div',{staticClass:"noSemiDataDonut"},[_c('v-img',{staticClass:"semiNoData",attrs:{"src":require("@/assets/semi-circle.png"),"width":"300","contain":""}})],1):_c('apexchart',{ref:"apexchart",attrs:{"type":"donut","options":_vm.chartOptions,"series":_vm.series,"height":_vm.height,"width":_vm.width}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }